import { waitForElementToExist } from '../utilities'

function hideBuyNowForNoStock () {
  if (window.theme.settings.template !== 'product.supadu') return
  const buyNowButton = document.querySelector('.shopify-payment-button')
  if (!buyNowButton) return
  const item = window.theme.productData
  if (!item) return
  if (!item.available) buyNowButton.remove()
}

function replacePreviewLabel () {
  if (window.theme.settings.template !== 'product.supadu') return
  waitForElementToExist('a[title="Read Excerpt"]').then(previewLink => {
    const previewSpan = previewLink.querySelector('span')
    if (previewSpan) {
      previewSpan.textContent = 'See Inside >'
    }
  })
}

function modifyPreorderLogic () {
  if (window.theme.settings.template !== 'product.supadu') return
  const addToCart = document.querySelector('.add-to-cart')
  if (!addToCart) return
  const cartText = addToCart.querySelector('span')
  if (!cartText || cartText.textContent !== 'Pre-order') return

  const item = window.theme.staticProductData
  if (!item) return
  const { availability, hide } = item

  // change pre-order text to add to cart
  if (availability === 20 && !hide) {
    cartText.textContent = 'Add to cart'
  } else {
    addToCart.remove()
  }
}

function customFunctions () {
  hideBuyNowForNoStock()
  replacePreviewLabel()
  modifyPreorderLogic()
}

module.exports = { customFunctions }
